import { over } from "lodash";
import * as actions from "store/actions/home";

export interface HomeDashboardState {
	dashboardData: {
		users: {
			total: number;
		};
		meisOverDue: number;
		meis: {
			total: number;
		};
		overdueDas: {
			total: number;
		};
		overdueDasn: {
			total: number;
		};
		das: {
			[key: string]: number;
		};
	};
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: HomeDashboardState = {
	dashboardData: {
		users: {
			total: 0
		},
		meisOverDue: 0,
		meis: {
			total: 0
		},
		overdueDas: {
			total: 0
		},
		overdueDasn: {
			total: 0
		},
		das: {}
	},
	loading: false,
	errors: null
};

const dashboardReducer = (
	state = initialState,
	action: MyAction
): HomeDashboardState => {
	const { type, payload } = action;

	switch (type) {
		case actions.GET_HOME: {
			return {
				...state,
				loading: true,
				errors: null
			};
		}
		case actions.GET_HOME_SUCCESS: {
			return {
				...state,
				dashboardData: {
					users: payload.users || initialState.dashboardData.users,
					meis: payload.meis || initialState.dashboardData.meis,
					overdueDas:
						payload.overdueDas || initialState.dashboardData.overdueDas,
					overdueDasn:
						payload.overdueDasn || initialState.dashboardData.overdueDasn,
					meisOverDue:
						payload.meisOverDue || initialState.dashboardData.meisOverDue,
					das: payload.das || initialState.dashboardData.das
				},
				loading: false
			};
		}
		case actions.GET_HOME_FAILED: {
			return {
				...state,
				errors: payload,
				loading: false
			};
		}
		case actions.SET_VALUE: {
			return {
				...state,
				dashboardData: {
					...state.dashboardData,
					...payload
				}
			};
		}
		case actions.CLEAR_VALUES: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default dashboardReducer;
